import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tbody", "template"]

  connect() {
    this.newRow = null
  }

  addRow(event) {
    event.preventDefault()
    if (this.newRow) return
    const tpl = this.templateTarget.content.cloneNode(true)
    this.newRow = tpl.querySelector("tr")
    this.tbodyTarget.prepend(this.newRow)
    const input = this.newRow.querySelector("input,select,textarea")
    if (input) input.focus()
  }

  cancel(event) {
    event.preventDefault()
    if (this.newRow) {
      this.newRow.remove()
      this.newRow = null
    }
  }

  afterSave(event) {
    const { success } = event.detail
    if (success) {
      this.newRow = null
    }
  }
}
